import { render, staticRenderFns } from "./NormalSearchNav308.vue?vue&type=template&id=2beaf2cc&scoped=true"
import script from "./NormalSearchNav308.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav308.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beaf2cc",
  null
  
)

export default component.exports